<!-- Modern RD Button Replacement -->
<button *ngIf="_openRD && NDDTypeOpen" type="button"
  class="btn btn-sm btn-light btn-light-walai border rounded-pill text-dark px-3 shadow-none" (click)="openRD(item)"
  [hidden]="!_CheckOpenRDByCollection && !isArticle">
  <i class="bi bi-truck me-1"></i> {{ 'ResourceDelivery' | translate }}
</button>